import React from 'react';
import classNames from 'classnames';
import { RCCloseButton } from '../RCCloseButton';

interface IRCAlertBoxProps {
  type: 'info' | 'warning' | 'error' | 'success' | 'highlight' | 'plain';
  small?: boolean;
  unpadded?: boolean;
  inline?: boolean;
  children: React.ReactNode;
  onDismiss?: React.MouseEventHandler<HTMLButtonElement>;
  headerText?: string | React.ReactNode;
}

export function RCAlertBox({
  type,
  small,
  unpadded,
  inline,
  children,
  onDismiss,
  headerText,
}: IRCAlertBoxProps) {
  const isDismissible = !!onDismiss;

  const classes = classNames(
    'alert-box', // eslint-disable-line reverb-design-system/prefer-components-to-classname
    { 'alert-box--info': type === 'info' },
    { 'alert-box--warning': type === 'warning' },
    { 'alert-box--error': type === 'error' },
    { 'alert-box--success': type === 'success' },
    { 'alert-box--highlight': type === 'highlight' },
    { 'alert-box--plain': type === 'plain' },
    { 'alert-box--small': small },
    { 'alert-box--unpadded': unpadded },
    { 'alert-box--inline': inline },
    { 'alert-box--dismissible': isDismissible },
    { 'alert-box--with-header': !!headerText },
  );

  return (
    <div className={classes}>
      {headerText && (
        <header className="alert-box__header">
          <h3 className="alert-box__header-text">
            {headerText}
          </h3>
        </header>
      )}
      <div className="alert-box__content">
        {children}
      </div>
      {isDismissible &&
        <RCCloseButton onClick={onDismiss} />
      }
    </div>
  );
}
